import type { FeatureStatus } from '../types';
import { STATUS_CN } from '../types';

const COLORS: Record<FeatureStatus, string> = {
  AI_FOUND: '#f9a825',   // 琥珀 - 待确认
  CONFIRMED: '#2e7d32',  // 绿 - 已确认
  MODIFIED: '#1565c0',   // 蓝 - 已修改
  REJECTED: '#9e9e9e',   // 灰 - 已排除
};

interface Props {
  status: FeatureStatus;
  count?: number;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, count, size = 'md' }: Props) {
  return (
    <span className={`status-badge ${size}`}
          style={{ background: COLORS[status] }}>
      {STATUS_CN[status]}{count !== undefined && ` · ${count}`}
    </span>
  );
}